import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { IAppInfo } from './model';

export abstract class CheckVersionGuard implements CanActivate {
	abstract canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean;
}

export abstract class AppVersionService {
	abstract updateStarted$: Observable<any>;
	abstract get appInfo(): Partial<IAppInfo>;
	abstract update(info?: Partial<IAppInfo>): void;
	/**
	 * return object parsed from assets/release-info/app-info.json file
	 * that file auto generate after deploy
	 */
	abstract getAppInfoFromAssetFile(): Observable<Partial<IAppInfo>>;

	abstract hasRuntimeBuildNumber(): boolean;

	abstract getRuntimeBuildNumber(): number;

	abstract getRuntimeBuildTime(): number;

	abstract getRuntimeGitHash(): number;
}
